<script setup lang="ts">
import { BarChart } from '@/components/ui/chart-bar'
import { Card } from '@/components/ui/card'
import html2canvas from 'html2canvas'
import { computed, onMounted, ref } from 'vue'
import RepartitionFormationRepository from '@/repository/RepartitionFormationRepository'
import type { GetRepartitionFormationParAgenceViewModel } from '@/lib/types'
import CustomTooltip from './CustomTooltip.vue'

const downloadProcessing = ref<boolean>(false)
const repartitionData = ref<GetRepartitionFormationParAgenceViewModel[]>([])

// Keep the original data keys for accessing the API data
const dataCategories = ref<string[]>(['institut', 'metier', 'reglementaire'])

// Define display names for the categories
const displayNames = {
  'institut': 'Institut',
  'metier': 'Métier',
  'reglementaire': 'Réglementaire'
}

const filteredData = computed(() => {
  if (!repartitionData.value || repartitionData.value.length === 0) return []

  // Use the original data keys
  return repartitionData.value.map((item) => {
    const result: Record<string, any> = {
      agence_title: item.agence_title
    }

    // Use the original data keys
    dataCategories.value.forEach((dataCategory) => {
      result[dataCategory] = item[dataCategory] || 0
    })

    return result
  })
})

const downloadChart = async () => {
  const chartElement = document.querySelector('#chart-container') as HTMLElement
  downloadProcessing.value = true
  if (chartElement) {
    const canvas = await html2canvas(chartElement)
    const dataUrl = canvas.toDataURL('image/png')
    const link = document.createElement('a')
    link.href = dataUrl
    link.download = 'repartition-formations.png'
    link.click()
  }
  downloadProcessing.value = false
}

onMounted(async () => {
  repartitionData.value = await RepartitionFormationRepository.getRepartitionData()
})
</script>

<template>
  <Card title="Répartition des formations par agence">
    <template #actions>
      <div class="flex items-center gap-2">
        <button @click="downloadChart" :disabled="downloadProcessing" class="btn btn-primary">
          Télécharger
        </button>
      </div>
    </template>
    <BarChart
      id="chart-container"
      :data="filteredData"
      index="agence_title"
      :categories="dataCategories"
      :custom-tooltip="CustomTooltip"
    />
  </Card>
</template>
